import { SET_USER } from "../reducers/auth";

export const setUser = ({
  isLoading = true,
  isAuthenticated = false,
  user = {},
}) => ({
  type: SET_USER,
  isAuthenticated,
  isLoading,
  ...user,
});
